"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RailzApiReturnStructure = exports.RailzBusinessInfoMetadataSchema = exports.RailzApiQueryParams = exports.RailzConnect = exports.RailzAccountingServiceNameSchema = exports.RailzAccountingServiceNames = void 0;
const zod_1 = require("zod");
const Bank = __importStar(require("./Bank"));
const FinancialData = __importStar(require("./FinancialData"));
// https://docs.railz.ai/docs/supported-accounting-integrations
exports.RailzAccountingServiceNames = [
    'freshbooks',
    'dynamicsBusinessCentral',
    'oracleNetsuite',
    'quickbooksDesktop',
    'quickbooks',
    'sageBusinessCloud',
    'sageIntacct',
    'xero',
    'wave',
    'zohoBooks',
];
exports.RailzAccountingServiceNameSchema = zod_1.z.enum(exports.RailzAccountingServiceNames);
var RailzConnect;
(function (RailzConnect) {
    // https://docs.railz.ai/docs/railz-connect-event-listeners#authorization
    RailzConnect.SuccessAuthorizationDataSchema = zod_1.z.object({
        businessName: zod_1.z.string(),
        businessUuid: zod_1.z.string(),
        connectionUuid: zod_1.z.string(),
        serviceName: exports.RailzAccountingServiceNameSchema,
    });
})(RailzConnect || (exports.RailzConnect = RailzConnect = {}));
var RailzApiQueryParams;
(function (RailzApiQueryParams) {
    RailzApiQueryParams.accountingMethodIterable = ['accrual', 'cash'];
    RailzApiQueryParams.accountingMethodSchema = zod_1.z.enum(RailzApiQueryParams.accountingMethodIterable);
})(RailzApiQueryParams || (exports.RailzApiQueryParams = RailzApiQueryParams = {}));
exports.RailzBusinessInfoMetadataSchema = zod_1.z.object({
    businessName: zod_1.z.string(),
    legalName: zod_1.z.string(),
    businessType: zod_1.z.string(),
    accountingMethod: zod_1.z.string(),
    baseCurrency: zod_1.z.nativeEnum(Bank.Currency),
});
var RailzApiReturnStructure;
(function (RailzApiReturnStructure) {
    /**
     * Typing based on: https://docs.railz.ai/reference/businessinfo
     */
    RailzApiReturnStructure.BusinessInfoSchema = zod_1.z.object({
        meta: zod_1.z.object({
            reportId: zod_1.z.string(),
            connectionUuid: zod_1.z.string(),
        }),
        // Response includes more data but using subset for typeguard purpose
        data: exports.RailzBusinessInfoMetadataSchema,
    });
    const PaginationStructureSchema = zod_1.z.object({
        offset: zod_1.z.number(),
        limit: zod_1.z.number(),
        count: zod_1.z.number(),
    });
    const RailzStatusIterable = ['success', 'failed', 'pending', 'empty'];
    const RailzStatusSchema = zod_1.z.enum(RailzStatusIterable);
    const RailzReportMetaSchema = zod_1.z.object({
        reportId: zod_1.z.string(),
        startDate: zod_1.z.string(),
        endDate: zod_1.z.string(),
        connectionUuid: zod_1.z.string(),
        serviceName: exports.RailzAccountingServiceNameSchema,
        businessName: zod_1.z.string(),
        reportFrequency: FinancialData.ReportFrequencySchema,
        accountingMethod: RailzApiQueryParams.accountingMethodSchema,
        status: RailzStatusSchema,
        createdAt: zod_1.z.string(),
        updatedAt: zod_1.z.string(),
    });
    const RailzReportBaseDataSchema = zod_1.z.object({
        section: zod_1.z.string(),
        subSection: zod_1.z.string(),
        group: zod_1.z.string(),
        subGroup: zod_1.z.string(),
        account: zod_1.z.string(),
        value: zod_1.z.number(),
        fullyQualifiedName: zod_1.z.string(),
        depth: zod_1.z.number(),
        accountId: zod_1.z.string().optional(),
    });
    /**
     * *** Income Statement Example ***
     * section: 'Expenses',
     * subSection: 'Cost Of Goods Sold',
     * group: 'Cost Of Goods Sold',
     * subGroup: 'Closing Inventory',
     * accountId: '24',
     * subAccountId: 77,
     * account: 'Utilities',
     * subAccount: 'Telephone',
     * value: 74.36,
     * fullyQualifiedName: 'Utilities:Telephone',
     * depth: 2
     */
    const IncomeStatementSectionIterable = ['Income', 'Expenses'];
    const IncomeStatementSubSectionIterable = [
        'Income',
        'Cost Of Goods Sold',
        'Operating Expenses',
        'Other Income',
        'Other Expenses',
        'Uncategorized Expenses',
        'Uncategorized Income',
        'Expenses',
    ];
    RailzApiReturnStructure.RailzIncomeStatementDataSchema = RailzReportBaseDataSchema.extend({
        section: zod_1.z.enum(IncomeStatementSectionIterable),
        subSection: zod_1.z.enum(IncomeStatementSubSectionIterable),
        subAccountId: zod_1.z.number().optional(),
        subAccount: zod_1.z.string().optional(),
    });
    /**
     * *** Balance Sheet Example ***
     * section: 'Assets',
     * subSection: 'Current Assets',
     * group: 'Other Current Assets',
     * subGroup: 'Undeposited Funds',
     * accountId: '4',
     * account: 'Undeposited Funds',
     * value: 907.15,
     * fullyQualifiedName: 'Undeposited Funds',
     * depth: 1,
     * type: 'Other Current Asset',
     * subType: 'UndepositedFunds'
     */
    const BalanceSheetSectionIterable = ['Assets', 'Liabilities', 'Equity'];
    const BalanceSheetSubSectionIterable = [
        'Current Assets',
        'Non-Current Assets',
        'Current Liabilities',
        'Non-Current Liabilities',
        'Equity',
        'Other Assets',
        'Other Liabilities',
        'Expenses',
    ];
    RailzApiReturnStructure.RailzBalanceSheetDataSchema = RailzReportBaseDataSchema.extend({
        section: zod_1.z.enum(BalanceSheetSectionIterable),
        subSection: zod_1.z.enum(BalanceSheetSubSectionIterable),
        type: zod_1.z.string().optional(),
        subType: zod_1.z.string().optional(),
    });
    /**
     * To note, seems like the docs can be a bit off with the structures,
     * so need to sanity check against actual returned data
     */
    /**
     * Typing based on: https://docs.railz.ai/reference/getincomestatements
     */
    RailzApiReturnStructure.IncomeStatementSchema = zod_1.z.object({
        pagination: PaginationStructureSchema,
        reports: zod_1.z.array(zod_1.z.object({
            meta: RailzReportMetaSchema,
            data: zod_1.z.array(RailzApiReturnStructure.RailzIncomeStatementDataSchema),
        })),
    });
    /**
     * Typing based on: https://docs.railz.ai/reference/getbalancesheets
     */
    RailzApiReturnStructure.BalanceSheetSchema = zod_1.z.object({
        pagination: PaginationStructureSchema,
        reports: zod_1.z.array(zod_1.z.object({
            meta: RailzReportMetaSchema,
            data: zod_1.z.array(RailzApiReturnStructure.RailzBalanceSheetDataSchema),
        })),
    });
})(RailzApiReturnStructure || (exports.RailzApiReturnStructure = RailzApiReturnStructure = {}));
//# sourceMappingURL=Railz.js.map